import React from "react"

export const Error = message => (
  <div className="error_container">
    <div className="error_message">
      {message}
    </div>
  </div>
)